export default __webpack_public_path__ + "static/media/Asset5_lrg.fd5b4a14.png";